import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Documents from "../Components/ContentArea/Documents";

import {
  getDocumentData,
  updateDocument,
  clientProfile,
  getDocumentCheckList,
  getDownlaodDocument,
  getDocumentLink,
  addDocumentItem,
  familyMemberDetail,
  multiUploadDocument,
} from "../store/Actions";

const mapStateToProps = (state) => {
  return {
    getDocumentRes: state.documentReducer.getDocumentRes,
    updateDocumentRes: state.documentReducer.updateDocumentRes,
    clientProfile: state.clientProfileReducer.clientProfile,
    documentCheckListRes: state.documentReducer.documentCheckListRes,
    downloadDocumentRes: state.documentReducer.downloadDocumentRes,
    documentLinkRes: state.documentReducer.documentLinkRes,
    documentItemRes: state.documentReducer.documentItemRes,
    familyMemberDetail: state.clientProfileReducer.familyMemberDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetDocumentData: bindActionCreators(getDocumentData, dispatch),
    onAddDocument: bindActionCreators(updateDocument, dispatch),
    onGetClientProfile: bindActionCreators(clientProfile, dispatch),
    onGetDocumentCheckList: bindActionCreators(getDocumentCheckList, dispatch),
    onGetDownlaodDocument: bindActionCreators(getDownlaodDocument, dispatch),
    onGetDocumentLink: bindActionCreators(getDocumentLink, dispatch),
    onAddDocumentItem: bindActionCreators(addDocumentItem, dispatch),
    onGetFamilyMemberDetail: bindActionCreators(familyMemberDetail, dispatch),
    onAddMultiDocument: bindActionCreators(multiUploadDocument, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);
